import React from 'react'
import { Box } from '@mui/material';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import Footer from '../../component/footer/Footer';
import Profile from '../../component/common/Profile';
import ProfileTabs from '../../component/common/ProfileTabs';



const CustomerProfile = () => {
  return (
    <>
         <HeaderTwo/>
                {/* Home > Job > Active Job */}
                <Breadcrumb parent='Home' title='Job' title1='Active Job' />
                <Box
                sx={{
                    width: '100%',
                    maxWidth: 1207,
                    margin: 'auto',
                    padding: '0',
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',

                }}
            >

            <Profile/>
               
              <ProfileTabs/>  
               
                <Footer/>

            </Box>
    </>

  )
}

export default CustomerProfile;